import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DownloadButton, ConsolidationButton } from '@/components/ui/Button';

interface ActionsProps {
	isConsolidated?: boolean;
	isLoadingDownload?: boolean;
	isLoadingConsolidate?: boolean;
	onDownload?: () => void;
	onConsolidate?: () => void;
}

export function Actions({
	isConsolidated = false,
	isLoadingDownload = false,
	isLoadingConsolidate = false,
	onDownload,
	onConsolidate
}: Readonly<ActionsProps>): JSX.Element {
	return (
		<Row justify="end" gutter={[24, 0]}>
			<Col>
				<DownloadButton
					size="middle"
					onClick={onDownload}
					loading={isLoadingDownload}
					disabled={isLoadingConsolidate}
				>
					{I18n.get('Download PDF')}
				</DownloadButton>
			</Col>
			<Col>
				<ConsolidationButton
					size="middle"
					onClick={onConsolidate}
					freeze={isConsolidated}
					loading={isLoadingConsolidate}
					disabled={isLoadingDownload}
				>
					{isConsolidated ? I18n.get('Deconsolidate') : I18n.get('Consolidate analysis')}
				</ConsolidationButton>
			</Col>
		</Row>
	);
}
